import { render, staticRenderFns } from "./RelatedServiceFormWrapper.vue?vue&type=template&id=3e8a4475"
import script from "./RelatedServiceFormWrapper.vue?vue&type=script&lang=js"
export * from "./RelatedServiceFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports